(function () {
  function safeParseJson(response) {
    return response.text().then(function (text) {
      if (!text) return null;
      try {
        return JSON.parse(text);
      } catch (error) {
        return { error: text.slice(0, 240) };
      }
    });
  }

  function buildHeaders(config, token) {
    var headers = {
      Accept: 'application/json'
    };

    if (token) {
      headers.Authorization = 'Bearer ' + token;
      return headers;
    }

    if (config.allowLegacyAuthFallback && window.Shopify && window.Shopify.customer) {
      headers['X-Shopify-Customer-Email'] = window.Shopify.customer.email || '';
      headers['X-Shopify-Customer-Id'] = window.Shopify.customer.id || '';
    }

    return headers;
  }

  function setState(root, nextState) {
    root.setAttribute('data-state', nextState);
  }

  function setMessage(root, message, tone) {
    var messageNode = root.querySelector('[data-gift-membership-message]');
    if (!messageNode) return;

    if (!message) {
      messageNode.hidden = true;
      messageNode.textContent = '';
      messageNode.removeAttribute('data-tone');
      return;
    }

    messageNode.hidden = false;
    messageNode.textContent = message;
    messageNode.setAttribute('data-tone', tone || 'info');
  }

  function formatDate(value) {
    if (!value) return null;
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    return new Intl.DateTimeFormat('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    }).format(date);
  }

  function setGiftData(root, gift) {
    var emailNode = root.querySelector('[data-gift-membership-recipient]');
    var orderNode = root.querySelector('[data-gift-membership-order]');
    var dateNode = root.querySelector('[data-gift-membership-date]');
    var messageWrap = root.querySelector('[data-gift-membership-note-wrap]');
    var messageNode = root.querySelector('[data-gift-membership-note]');
    var cta = root.querySelector('[data-gift-membership-activate]');

    if (emailNode) emailNode.textContent = gift.recipient_email || 'your email';
    if (orderNode) orderNode.textContent = gift.shopify_order_name || 'your gift order';
    if (dateNode) dateNode.textContent = formatDate(gift.created_at) || 'recently';

    var note = (gift.gift_message || '').trim();
    if (messageWrap && messageNode) {
      if (note) {
        messageWrap.hidden = false;
        messageNode.textContent = note;
      } else {
        messageWrap.hidden = true;
        messageNode.textContent = '';
      }
    }

    if (cta) {
      cta.setAttribute('data-gift-id', gift.id || '');
    }
  }

  async function requestGiftSession(config) {
    var response = await fetch(config.authBridgeUrl, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    });
    var payload = await safeParseJson(response);
    if (!response.ok || !payload || !payload.token) {
      throw new Error((payload && payload.error) || 'Unable to verify your account session.');
    }
    return payload.token;
  }

  async function fetchPendingGift(config, token) {
    var response = await fetch(config.giftApiBaseUrl.replace(/\/$/, '') + '/gift-membership/me/pending', {
      method: 'GET',
      headers: buildHeaders(config, token),
      credentials: 'omit'
    });
    var payload = await safeParseJson(response);
    if (!response.ok) {
      throw new Error((payload && payload.error) || 'Unable to load your gift status right now.');
    }
    return payload;
  }

  async function activateGift(config, token, giftId) {
    var response = await fetch(config.giftApiBaseUrl.replace(/\/$/, '') + '/gift-membership/activate', {
      method: 'POST',
      headers: Object.assign(
        {
          'Content-Type': 'application/json'
        },
        buildHeaders(config, token)
      ),
      credentials: 'omit',
      body: JSON.stringify({ giftId: giftId || null })
    });
    var payload = await safeParseJson(response);
    if (!response.ok) {
      throw new Error((payload && payload.error) || 'Activation failed.');
    }
    return payload;
  }

  function getCustomer() {
    return window.Shopify && window.Shopify.customer ? window.Shopify.customer : null;
  }

  function withReturnUrl(baseUrl, returnUrl) {
    if (!baseUrl) return '';

    try {
      var url = new URL(baseUrl, window.location.origin);
      if (returnUrl) {
        url.searchParams.set('return_url', returnUrl);
        url.searchParams.set('return_to', returnUrl);
      }
      return url.toString();
    } catch (error) {
      return baseUrl;
    }
  }

  async function loadGiftState(root, config) {
    setMessage(root, '', 'info');

    var customer = getCustomer();
    if (!customer || !customer.email) {
      setState(root, 'logged-out');
      return;
    }

    setState(root, 'loading');

    try {
      var token = null;

      try {
        token = await requestGiftSession(config);
      } catch (error) {
        if (!config.allowLegacyAuthFallback) {
          throw error;
        }
      }

      var pendingPayload = await fetchPendingGift(config, token);
      if (!pendingPayload || !pendingPayload.gift) {
        setState(root, 'no-gift');
        return;
      }

      root._giftMembershipToken = token;
      root._giftMembershipGift = pendingPayload.gift;
      setGiftData(root, pendingPayload.gift);
      setState(root, 'ready');
    } catch (error) {
      setState(root, 'error');
      setMessage(root, error.message || 'Something went wrong while checking your gift.', 'error');
    }
  }

  function bindActivate(root, config) {
    var button = root.querySelector('[data-gift-membership-activate]');
    if (!button) return;

    button.addEventListener('click', async function () {
      if (button.disabled) return;

      button.disabled = true;
      setMessage(root, '', 'info');

      try {
        var gift = root._giftMembershipGift || {};
        var payload = await activateGift(config, root._giftMembershipToken || null, gift.id || button.getAttribute('data-gift-id'));
        root._giftMembershipActivated = payload.gift || gift;
        setState(root, 'success');
      } catch (error) {
        setState(root, 'ready');
        setMessage(root, error.message || 'Activation failed. Please try again.', 'error');
      } finally {
        button.disabled = false;
      }
    });
  }

  function bindRetry(root, config) {
    var retry = root.querySelector('[data-gift-membership-retry]');
    if (!retry) return;

    retry.addEventListener('click', function () {
      loadGiftState(root, config);
    });
  }

  function bindAuthLinks(root, config) {
    var authLinks = root.querySelectorAll('[data-gift-membership-auth-link]');
    if (!authLinks.length) return;

    var returnUrl = window.location.pathname + window.location.search;
    authLinks.forEach(function (link) {
      var baseHref = link.getAttribute('href') || '';
      if (!baseHref) return;
      link.setAttribute('href', withReturnUrl(baseHref, returnUrl));
    });
  }

  function bindSwitchAccount(root, config) {
    var switchLinks = root.querySelectorAll('[data-gift-membership-switch-account]');
    if (!switchLinks.length) return;

    var returnUrl = window.location.pathname + window.location.search;
    var logoutUrl = config.logoutUrl || '/account/logout';
    var loginUrl = withReturnUrl(config.loginUrl || '/account/login', returnUrl);

    switchLinks.forEach(function (link) {
      link.addEventListener('click', async function (event) {
        event.preventDefault();
        setMessage(root, 'Signing you out so you can switch accounts...', 'info');

        try {
          await fetch(logoutUrl, {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-store',
            redirect: 'follow'
          });
        } catch (error) {
          // Continue to the login page even if the logout request fails silently.
        }

        window.location.assign(loginUrl);
      });
    });
  }

  function init(root) {
    var config = {
      giftApiBaseUrl: root.getAttribute('data-gift-api-base-url') || '',
      authBridgeUrl: root.getAttribute('data-auth-bridge-url') || '',
      memberDashboardUrl: root.getAttribute('data-member-dashboard-url') || '/account',
      loginUrl: root.getAttribute('data-login-url') || '/account/login',
      logoutUrl: root.getAttribute('data-logout-url') || '/account/logout',
      allowLegacyAuthFallback: root.getAttribute('data-allow-legacy-auth-fallback') === 'true'
    };

    if (!config.giftApiBaseUrl || !config.authBridgeUrl) {
      setState(root, 'error');
      setMessage(root, 'Activation page is missing its API configuration.', 'error');
      return;
    }

    bindAuthLinks(root, config);
    bindSwitchAccount(root, config);
    bindActivate(root, config);
    bindRetry(root, config);
    loadGiftState(root, config);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-gift-membership-activate-root]').forEach(init);
  });
})();
